import * as React from "react";

import { FilterInfo } from "../../../FilteringControls/FilterInfo/FilterInfo";

interface CrossfitTableFilterInfoSidebarRowProps {
    children: React.ReactElement<FilterInfo>;
}

export function CrossfitTableFilterInfoSidebarRow(props: CrossfitTableFilterInfoSidebarRowProps): JSX.Element {
    return (
        <tr>
            <td>{props.children}</td>
        </tr>
    );
}
